import { styled } from '@mui/material';
import { GridFilterPanel } from '@mui/x-data-grid-pro';
import { headingFontBold } from '../../../../Theme';

/**
 * Reduces the default font size of the Data Grid's filter panel.
 */
export default styled(GridFilterPanel)(() => ({
    '& .MuiInput-root': { ...headingFontBold, fontSize: 14 },
}));
